import { useContext } from 'react'
import { checkPagePermissions } from '@BUP/rbac'
import NotAllowedPage from '@BUP/pages/NotAllowed'
import { RoleContext } from '@BUP/contexts/RoleContext'

import { useLocation } from 'react-router-dom'

const RoleRoute = ({ children, name: pageName }) => {
  const role = useContext(RoleContext)
  const userRole = role?.type
  const location = useLocation()
  const currentPath = location.pathname

  // pass the actual pathname so permission logic can compare correctly
  if (!checkPagePermissions(pageName, userRole, currentPath)) {
    return <NotAllowedPage />
  }

  return children
}

export default RoleRoute
